import PropTypes from 'prop-types';

export const columnShape = PropTypes.shape({
  header_name: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  column_type: PropTypes.string.isRequired,
  input_name: PropTypes.string,
  required: PropTypes.bool,
  description: PropTypes.string,
  column_type_name: PropTypes.string,
  visible: PropTypes.bool,
  custom_data: PropTypes.object,
  empty_value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.any
  ]),
  text_limit: PropTypes.number,
  allowed_characters: PropTypes.array,
  prohibited_characters: PropTypes.array,
  allow_combo_generate: PropTypes.bool,
  allow_create: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.string.isRequired,
    description: PropTypes.string,
    color: PropTypes.string
  })),
  date_format: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  is_parent: PropTypes.bool,
  current_value: PropTypes.string,
  show_description: PropTypes.bool
});

export const gridModeUrlBuilderPropTypes = {
  url_columns: PropTypes.arrayOf(columnShape).isRequired,
  field_columns: PropTypes.arrayOf(columnShape).isRequired,
  other_columns: PropTypes.arrayOf(columnShape).isRequired,
  initial_row_data: PropTypes.arrayOf(PropTypes.object).isRequired,
  initial_pinned_row_data: PropTypes.object.isRequired,
};